import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import Archive from './Archive';
//import registerServiceWorker from './registerServiceWorker';

ReactDOM.render(<Archive />, document.getElementById('archive-root'));
//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js